export const ColumnsKeys = Object.freeze({
  tableColumns: "tableColumns"
});
